import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { useTranslation } from "../hooks/useTranslation";
import "../assets/styles/notFoundPage.css";

export default function NotFound() {
  const t = useTranslation();

  return (
    <section className="notfound-page">
      <div className="glass-wrapper notfound-card">
        <img src={logo} alt="Logo" className="notfound-logo" />

        <h1 className="notfound-title">
          {t("notfound.title")}{" "}
          <span role="img" aria-label="Thinking face">
            🤔
          </span>
        </h1>

        <p className="notfound-message">
          {t("notfound.message") || "404 – A keresett oldal nem található."}
        </p>

        <Link to="/" className="notfound-btn">
          {t("notfound.backhome")}
        </Link>
      </div>
    </section>
  );
}
